import { render } from "./globalLoading.vue?vue&type=template&id=1fe34b4a&scoped=true"
import script from "./globalLoading.vue?vue&type=script&lang=js"
export * from "./globalLoading.vue?vue&type=script&lang=js"

import "./globalLoading.vue?vue&type=style&index=0&id=1fe34b4a&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/huiduoduo/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe34b4a"]])

export default __exports__